// extracted by mini-css-extract-plugin
var _1 = "q8p0K";
var _2 = "gSnNL";
var _3 = "vK8uG";
var _4 = "x2rsB";
var _5 = "FTkl0";
var _6 = "Qg4NQ";
var _7 = "GM0fZ";
var _8 = "Fsbi9";
var _9 = "QOnUN";
var _a = "D9GKm";
var _b = "gTEWu";
var _c = "ityQ0";
var _d = "g2GCv";
var _e = "JICPd";
var _f = "mPM1l";
export { _1 as "container", _2 as "content", _3 as "description", _4 as "description-bold", _5 as "disclaimer", _6 as "email", _7 as "menu", _8 as "message", _9 as "message-branding", _a as "message-description", _b as "message-icon", _c as "message-title", _d as "send-copy", _e as "title", _f as "warning" }
